import { render, staticRenderFns } from "./CommunicationRulesPage.vue?vue&type=template&id=56cba0bc&scoped=true&"
import script from "./CommunicationRulesPage.vue?vue&type=script&lang=js&"
export * from "./CommunicationRulesPage.vue?vue&type=script&lang=js&"
import style0 from "./CommunicationRulesPage.vue?vue&type=style&index=0&id=56cba0bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cba0bc",
  null
  
)

export default component.exports